(() => {
  'use strict';

  if (window.LMHalloweenAnnouncement) {
    window.LMHalloweenAnnouncement.init(document);
    return;
  }

  const selector = '[data-lm-halloween-announcement]';
  const controllers = new Map();

  function mount(root) {
    if (controllers.has(root)) return;
    const button = root.querySelector('[data-lm-halloween-motion]');
    const label = root.querySelector('[data-lm-halloween-motion-label]');
    const pauseIcon = root.querySelector('[data-lm-halloween-pause]');
    const playIcon = root.querySelector('[data-lm-halloween-play]');
    if (!button || !label || !pauseIcon || !playIcon || !window.matchMedia) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const compact = window.matchMedia('(max-width: 767px)');
    const listeners = [];
    let userPaused = false;
    let hovered = false;
    let destroyed = false;

    function sync() {
      if (destroyed) return;
      const reduced = reducedMotion.matches;
      if (reduced && document.activeElement === button) {
        root.querySelector('a')?.focus();
      }
      root.toggleAttribute('data-lm-halloween-enhanced', !reduced);
      button.hidden = reduced;
      root.dataset.lmHalloweenPaused = String(
        reduced || userPaused || hovered || root.contains(document.activeElement)
      );
      label.textContent = userPaused ? 'Play' : 'Pause';
      button.setAttribute('aria-label', userPaused ? 'Play scrolling' : 'Pause scrolling');
      pauseIcon.hidden = userPaused;
      playIcon.hidden = !userPaused;
    }

    function listen(element, name, handler) {
      element.addEventListener(name, handler);
      listeners.push(() => element.removeEventListener(name, handler));
    }

    listen(button, 'click', () => { userPaused = !userPaused; sync(); });
    listen(root, 'pointerenter', (event) => {
      if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
        hovered = true;
        sync();
      }
    });
    listen(root, 'pointerleave', () => { hovered = false; sync(); });
    listen(root, 'focusin', sync);
    listen(root, 'focusout', () => { queueMicrotask(sync); });
    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', sync);
      listeners.push(() => reducedMotion.removeEventListener('change', sync));
    } else {
      reducedMotion.addListener(sync);
      listeners.push(() => reducedMotion.removeListener(sync));
    }

    if(compact.addEventListener){compact.addEventListener('change',sync);listeners.push(()=>compact.removeEventListener('change',sync));}
    controllers.set(root, () => {
      destroyed = true;
      listeners.forEach((remove) => remove());
      root.removeAttribute('data-lm-halloween-enhanced');
      root.removeAttribute('data-lm-halloween-paused');
      button.hidden = true;
      controllers.delete(root);
    });
    sync();
  }

  function init(scope) {
    controllers.forEach((destroy, root) => { if (!root.isConnected) destroy(); });
    if (scope.matches?.(selector)) mount(scope);
    scope.querySelectorAll(selector).forEach(mount);
  }

  function unmount(scope) {
    controllers.forEach((destroy, root) => {
      if (!root.isConnected || root === scope || scope.contains(root)) destroy();
    });
  }

  window.LMHalloweenAnnouncement = { init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => unmount(event.target));
  window.addEventListener('pagehide', () => controllers.forEach((destroy) => destroy()));
  window.addEventListener('pageshow', () => init(document));
})();
